class SliderImage extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initSlider();
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  initSlider() {
    this.swiper = new Swiper(".swiper-image", {
      slidesPerView: "auto",
      spaceBetween: 6,
      freeMode: {
        enabled: true,
        sticky: true,
        momentumRatio: 0.5,
      },
      mousewheel: {
        forceToAxis: true,
        thresholdDelta: 15,
        thresholdTime: 100,
        releaseOnEdges: true,
      },
      breakpoints: {
        990: {
          spaceBetween: 8,
        },
      },
    });
  }
}

customElements.define("slider-image", SliderImage);
